/* eslint-disable import/no-default-export */
import { HeaderTestIds } from '@trello/webdriverio-tests';
// eslint-disable-next-line no-restricted-imports
import { IconName } from 'common/components/controls/icon';
// eslint-disable-next-line no-restricted-imports
import { InfoMenuPopoverId } from 'components/popovers/popover-ids';
// eslint-disable-next-line no-restricted-imports
import { showPopover, State } from 'modules';
import React, { lazy, Suspense } from 'react';
import { connect, Dispatch } from 'react-redux';
// eslint-disable-next-line no-restricted-imports
import { isPopoverShown } from 'selectors/popovers';

// eslint-disable-next-line no-restricted-imports
import { Noun, Verb } from 'common/debug/analytics-constants';
// eslint-disable-next-line no-restricted-imports
import Analytics from 'debug/analytics';
import HeaderButton from './button';

const HeaderInfoMenuPopoverPromise = import(/* webpackChunkName: "gamma-info-menu-popover" */ 'components/popovers/header-info-menu');
const HeaderInfoMenuPopover = lazy(() => HeaderInfoMenuPopoverPromise);

interface Props {
  isActive: boolean;
  onClick: React.EventHandler<React.MouseEvent<HTMLButtonElement>>;
}

class InfoMenuButton extends React.Component<Props> {
  infoButtonRef = React.createRef<HTMLButtonElement>();

  render() {
    const { isActive, onClick }: Props = this.props;

    return (
      <>
        <HeaderButton
          icon={IconName.Information}
          onClick={onClick}
          ref={this.infoButtonRef}
          testId={HeaderTestIds.InfoButton}
        />
        {isActive && (
          <Suspense fallback={null}>
            <HeaderInfoMenuPopover target={() => this.infoButtonRef.current} />
          </Suspense>
        )}
      </>
    );
  }
}

const mapStateToProps = (state: State) => {
  return {
    isActive: isPopoverShown(state, InfoMenuPopoverId),
  };
};

const mapDispatchToProps = (dispatch: Dispatch<State>) => {
  return {
    onClick(e: React.MouseEvent<HTMLElement>) {
      Analytics.trackUE({
        category: Noun.HEADER,
        verb: Verb.OPENS,
        directObj: Noun.INFO_MENU,
        method: 'clicking info header button',
      });

      dispatch(showPopover({ name: InfoMenuPopoverId }));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(InfoMenuButton);



// WEBPACK FOOTER //
// ./app/gamma/src/components/header/info-menu-button.tsx